import ImageViewerModal from 'app/design/primitives/image-viewer-modal';

export function ListingThumbnailImageViewer({
  imageUrls,
  onClose,
  visible,
}: {
  imageUrls: { url: string }[];
  onClose: () => void;
  visible: boolean;
}) {
  if (!visible) return null;
  return <ImageViewerModal imageUrls={imageUrls} onClose={onClose} open />;
}
